var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import filtersIcon from '../../assets/images/icons/common/icon-filters-purple.png';
import { SettingsContext } from '../../context/settings';
import InputText from '../common/input-text';
export default function MobileToolbar(_a) {
    var searchQuery = _a.searchQuery;
    var t = useI18n().t;
    var _b = useContext(SettingsContext), showChangelogMenu = _b.showChangelogMenu, setShowChangelogMenu = _b.setShowChangelogMenu;
    var showSearchBar = useState(false)[0];
    // function onSearchClick() {
    //   setShowSearchBar(!showSearchBar)
    // }
    return (_jsxs(Container, { className: "mobile-only", showChangelogMenu: showChangelogMenu, children: [_jsx("div", { className: "left-container", children: showSearchBar ? (_jsx(InputText, { label: t('common.search-bar.label'), onChange: searchQuery.bind.onChange, search: true, value: searchQuery.value })) : (_jsxs(_Fragment, { children: [_jsx(FiltersButton, { onClick: function () { return setShowChangelogMenu(true); }, children: _jsx("img", { alt: "filters", src: filtersIcon }) }), _jsx("p", { children: t('changelog.menu.title') })] })) }), _jsx("div", { className: "right-container" })] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-top: ", ";\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  height: 64px;\n  justify-content: space-between;\n  left: 0;\n  padding: 0 16px;\n  position: fixed;\n  transition: padding-left 200ms ease-in-out;\n  width: 100%;\n  z-index: 1;\n\n  .left-container {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    height: 100%;\n    justify-content: flex-start;\n\n    & > p {\n      font-size: 16px;\n      font-weight: 700;\n      text-transform: uppercase;\n    }\n\n    .input-text {\n      width: 240px;\n    }\n  }\n\n  .right-container {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    height: 100%;\n    justify-content: flex-end;\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-top: ", ";\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  height: 64px;\n  justify-content: space-between;\n  left: 0;\n  padding: 0 16px;\n  position: fixed;\n  transition: padding-left 200ms ease-in-out;\n  width: 100%;\n  z-index: 1;\n\n  .left-container {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    height: 100%;\n    justify-content: flex-start;\n\n    & > p {\n      font-size: 16px;\n      font-weight: 700;\n      text-transform: uppercase;\n    }\n\n    .input-text {\n      width: 240px;\n    }\n  }\n\n  .right-container {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    height: 100%;\n    justify-content: flex-end;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutNeutralDark;
}, function (_a) {
    var theme = _a.theme;
    return "solid 1px ".concat(theme.palette.purple, "80");
});
var FiltersButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-shrink: 0;\n  height: 40px;\n  width: 40px;\n\n  & > img {\n    height: 100%;\n    width: 100%;\n  }\n"], ["\n  flex-shrink: 0;\n  height: 40px;\n  width: 40px;\n\n  & > img {\n    height: 100%;\n    width: 100%;\n  }\n"
    // const CircleButton = styled.button<{ selected: boolean }>`
    //   background-image: ${({ selected }) =>
    //     selected ? 'linear-gradient(to right, #c1a16c, #e7c9a2 50%, #c1a16c)' : 'none'};
    //   border-radius: 50px;
    //   box-shadow: ${({ selected }) => (selected ? 'l0 0 6px 0 #ffb800' : 'none')};
    //   height: 44px;
    //   padding: 2px;
    //   width: 44px;
    //   .button-overlay-1 {
    //     background-color: ${({ theme }) => theme.palette.layoutNeutralDark};
    //     border-radius: 50px;
    //     height: 100%;
    //     width: 100%;
    //     .button-overlay-2 {
    //       background-image: ${({ selected }) =>
    //         selected ? 'linear-gradient(to bottom, #423686 1%, #171940 46%, #1e1e48 64%, #312b60 92%)' : 'none'};
    //       border-radius: 50px;
    //       height: 100%;
    //       position: relative;
    //       width: 100%;
    //       .ornament {
    //         height: 100%;
    //         width: 100%;
    //       }
    //       .icon {
    //         height: 28px;
    //         left: 6px;
    //         position: absolute;
    //         top: 6px;
    //         width: 28px;
    //       }
    //     }
    //   }
    // `
])));
var templateObject_1, templateObject_2;
